import { useSelector } from "react-redux";

import { useTranslate } from "@similarweb/i18n-provider";

import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";
import siNavigator from "app/pages/sales-intelligence/services/siNavigator";
import {
    ADMIN_ENABLE_EXPORT_INTEGRATION_TOOLTIP,
    CONNECT_TO_INTEGRATION_TOOLTIP,
    CRM_IS_NOT_CONNECTED_TOOLTIP,
} from "app/pages/sales-intelligence/sub-modules/management/translations/ExportItem";

import WebsitesHubSpotExportItem from "../../components/WebsitesHubSpotExportItem/WebsitesHubSpotExportItem";
import { selectHubspotStatus, selectIsHubspotExportEnabled } from "../../store/selectors/hubspotSelectors";

type WebsitesHubSpotExportItemContainerProps = {
    onClick: () => void;
    tooltipDisabledContent?: string;
    isUseLockedIcon?: boolean;
};

const WebsitesHubSpotExportItemContainer = ({
    onClick,
    tooltipDisabledContent,
    isUseLockedIcon = true,
}: WebsitesHubSpotExportItemContainerProps) => {
    const syncStatus = useSelector(selectHubspotStatus);
    const isExportEnabled = useSelector(selectIsHubspotExportEnabled);

    const { translate } = useTranslate();

    const redirectToManagementPage = () => {
        void siNavigator.goToManagementPage({
            isScrollToIntegrationSection: true,
        });
    };

    const isAdmin = salesSettingsHelper.isAdmin();

    if (tooltipDisabledContent) {
        return (
            <WebsitesHubSpotExportItem
                isDisabled={true}
                onClick={onClick}
                isUseLockedIcon={isUseLockedIcon}
                tooltipDisabledContent={tooltipDisabledContent}
            />
        );
    }
    if (syncStatus === "NotIntegrated") {
        if (isAdmin) {
            return (
                <WebsitesHubSpotExportItem
                    isDisabled={false}
                    onClick={redirectToManagementPage}
                    isUseLockedIcon={isUseLockedIcon}
                    text={translate(CONNECT_TO_INTEGRATION_TOOLTIP, { integrationName: "HubSpot" })}
                />
            );
        } else {
            return (
                <WebsitesHubSpotExportItem
                    isDisabled={true}
                    onClick={onClick}
                    isUseLockedIcon={isUseLockedIcon}
                    tooltipDisabledContent={translate(CRM_IS_NOT_CONNECTED_TOOLTIP)}
                />
            );
        }
    }

    if (isAdmin && !isExportEnabled) {
        return (
            <WebsitesHubSpotExportItem
                isDisabled={false}
                onClick={redirectToManagementPage}
                isUseLockedIcon={isUseLockedIcon}
                tooltipContent={translate(ADMIN_ENABLE_EXPORT_INTEGRATION_TOOLTIP)}
            />
        );
    }

    return (
        <WebsitesHubSpotExportItem
            isDisabled={!isExportEnabled}
            onClick={onClick}
            isUseLockedIcon={isUseLockedIcon}
        />
    );
};

export default WebsitesHubSpotExportItemContainer;
